// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1eMM_","errors":"Errors_errors__1PUvJ"};